<div fxLayout="row" fxLayoutGap="4px">
  <app-chip
    *ngIf="isPrivateSegment"
    class="u-marginBottom-8"
    i18n="@@groupCustomPrivateSegments.privateSegmentLabel"
    >Private segment
  </app-chip>
  <app-chip class="u-marginBottom-8">
    <ng-container
      *ngIf="isMultiSelection; else singleChoice"
      i18n="@@groupCustomPrivateSegments.multipleSelectionType"
      >Select multiple options</ng-container
    >
    <ng-template #singleChoice>
      <ng-container i18n="@@groupCustomPrivateSegments.singleSelectionType"
        >Single choice</ng-container
      >
    </ng-template>
  </app-chip>
  <app-chip
    *ngIf="customSegment.is_selectable_for_user_introduction_goals"
    class="u-marginBottom-8"
    iconPrefix="swap_horizontal_circle"
    i18n="@@groupCustomPrivateSegments.selectableForMatchingRules"
  >
    Member-level matching rule
  </app-chip>
  <app-chip
    *ngIf="privacySettings?.viewable_by_self"
    class="u-marginBottom-8"
    i18n="@@groupCustomPrivateSegments.viewableBySelf"
  >
    Visible to profile owner
  </app-chip>
</div>
